import Placeholder from '@assets/imagePlaceholderB&W.png';
import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { Box, styled, Typography } from '@mui/material';

type ImagePlaceholderTsoPqProps = {
  title?: string;
  description?: string;
};

const StyledContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    background: tsoPqTheme.palette.background.other.color_other_background_white,
    padding: `${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_m} ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_s}`, // todo change it component spacing values when spacinv values are added
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_s,
    borderRadius: tsoPqTheme.shape.border_radius_tso_border_radius_4,
  };
});

const StyledContent = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_16,
  };
});

const StyledTitle = styled(Typography)(() => {
  return {
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_body_body_large,
    fontWeight: 700,
    color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
    textAlign: 'center',
    lineHeight: tsoPqTheme.typography.lineHeight_xl,
  };
});

const StyledDescriprion = styled(Typography)(() => {
  return {
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_body_body_large,
    fontWeight: 400,
    color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
    textAlign: 'center',
    lineHeight: tsoPqTheme.typography.lineHeight_xl,
  };
});

const StyledImage = styled('img')(() => {
  return {
    display: 'flex',
    height: '12.375rem',
    width: '18.75rem',
    alignSelf: 'center',
  };
});

const ImagePlaceholderTsoPq = ({ title, description }: ImagePlaceholderTsoPqProps) => {
  return (
    <StyledContainer>
      <StyledContent>
        <StyledTitle>{title}</StyledTitle>
        <StyledDescriprion>{description}</StyledDescriprion>
        <StyledImage src={Placeholder} />
      </StyledContent>
    </StyledContainer>
  );
};

export default ImagePlaceholderTsoPq;
